import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import Logo from "../components/Logo";
import { MenuPanel, TabBtn } from "./AdminDashboard";
import OwnerOrdersPanel from "../components/owner/OwnerOrdersPanel";

export default function OwnerDashboard() {
    const navigate = useNavigate();
    const [tab, setTab] = useState("orders");
    const [user, setUser] = useState(null);

    useEffect(() => {
        if (!localStorage.getItem("owner_token")) {
            navigate("/owner/login", { replace: true });
            return;
        }
        api.get("/owner/me")
            .then((r) => setUser(r.data))
            .catch(() => {
                localStorage.removeItem("owner_token");
                navigate("/owner/login", { replace: true });
            });
    }, [navigate]);

    const logout = () => {
        localStorage.removeItem("owner_token");
        navigate("/owner/login", { replace: true });
    };

    if (!user) {
        return (
            <div className="py-20 text-center text-text-muted">
                <i className="fa-solid fa-spinner fa-spin text-2xl text-brand" />
            </div>
        );
    }

    return (
        <div data-testid="owner-dashboard" className="max-w-md mx-auto md:max-w-4xl lg:max-w-6xl px-4 py-6">
            <header className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                    <Logo size={44} />
                    <div>
                        <div className="font-black text-text-main text-lg">لوحة صاحب المطعم</div>
                        <div className="text-xs text-text-muted" data-testid="owner-email-label" dir="ltr">{user.email}</div>
                    </div>
                </div>
                <button
                    onClick={logout}
                    data-testid="owner-logout"
                    className="bg-white border-2 border-[var(--border-subtle)] rounded-xl px-3 py-2 text-sm font-bold text-text-main hover:border-brand hover:text-brand transition"
                >
                    <i className="fa-solid fa-right-from-bracket ms-1" /> خروج
                </button>
            </header>

            <div className="flex gap-2 mb-6 overflow-x-auto no-scrollbar">
                <TabBtn id="orders" cur={tab} setCur={setTab} icon="fa-receipt" label="الطلبات" />
                <TabBtn id="menu" cur={tab} setCur={setTab} icon="fa-utensils" label="المنيو" />
            </div>

            {tab === "orders" && <OwnerOrdersPanel />}
            {tab === "menu" && <MenuPanel />}
        </div>
    );
}
